import React, { useState, useEffect, useRef } from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { getTokenPayload } from '../../../utils/auth';

export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const Header = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const dropdownRef = useRef(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Load user from cookie when component mounts
  useEffect(() => {
    const payload = getTokenPayload();
    if (payload) {
      setUser(payload);
      setIsLoggedIn(true);
    }
  }, []);

  // Handle click outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    const confirmed = window.confirm('Are you sure you want to logout?');
    if (confirmed) {
      cookies.remove("authToken", { path: "/" });
      setUser(null);
      setIsLoggedIn(false);
      navigate("/");
    }
  };

  const handleAvatarClick = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const GoToDashboard = () => {
    navigate("/dashboard/home");
  };

  return (
    <div className="fixed z-50 top-0 left-0 w-full bg-blue-950 h-28">
      <nav className="md:flex justify-between px-10 md:min-h-[10vh] md:h-24 h-32 pb-3 items-center text-txtclr mt-4">
        <div className="flex md:gap-8 justify-between gap-5 mb-5 md:mb-0 pt-5 md:pt-0">
          <div className="flex md:items-center">
            {/* <Link to="/"> */}
              <img
                className="md:w-64 w-44"
                src="https://cdn.clevdoc.com/assets/logo/clevdoc_logo.png"
                alt="Clevdoc"
              />
            {/* </Link> */}
          </div>
        </div>

        <div className="flex items-center text-white justify-end gap-1">
          {isLoggedIn ? (
            <div className="relative inline-block" ref={dropdownRef}>
              <button onClick={handleAvatarClick} className="flex text-xl hover:text-red-600">
                Welcome, {capitalizeFirstLetter(user?.first_name || user?.name || "User")}
                <div className="mt-1.5 ml-1">
                  <FaAngleDown />
                </div>
              </button>

              {isDropdownOpen && (
                <div className="absolute right-5 mt-1 px-3 py-1.5 w-36 text-center bg-white rounded shadow">
                  <ul className="text-md text-gray-800">
                    <li>
                      <button
                        onClick={GoToDashboard}
                        className="block w-full text-left border-b pb-2 pt-3 hover:font-semibold text-blue-800"
                      >
                        Go to Dashboard
                      </button>
                    </li>
                    <li>
                      <button
                        className="block w-full text-left py-2 hover:font-semibold text-red-600"
                        onClick={handleLogout}
                      >
                        Log out
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login">
              <button className="flex text-md p-1 px-3 rounded border hover:text-red-600 hover:border-red-600 ring-1">
                Log In
              </button>
            </Link>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Header;
